
























































import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import { StaffEntity } from '@/entities/staff.entity';
import { mapGetters } from 'vuex';
import CheeersCheck from '@/assets/image/cheeers_check.png';
import templateMixin from './templateMixin';

@Component<SurveyQuestion>({
  mixins: [templateMixin],
  computed: {
    ...mapGetters('staff', ['currentStaff']),
  },
  data: () => ({
    tempShow: false,
    CheeersCheck,
  }),
  mounted() {
    /**
     * NOTICE: This is a temporary variable used to delete notification data of the survey question when the question is reused, so we delete it
     */
    this.$store.dispatch('staff/removeFirstNotification')
  },
})
export default class SurveyQuestion extends Vue {
  close!: () => void;
  currentStaff!: StaffEntity;

  get notifyId() {
    return Number((this.$attrs.currentNotify as any).id);
  }

  async directCheckSurveyQuestionPage() {
    this.close();
    await new Promise((resolve) => {
      setTimeout(() => {
        this.close();
        resolve(true);
      }, 500);
    });
    await this.$router.push('/e-learning/test/survey-question');
  }
}
